<template>
  <div class="content">
    <div class="d-flex align-center h-100">
      <v-card class="mx-auto pa-12 pb-8" elevation="8" width="400" max-width="448" rounded="lg">
        <v-img class="mx-auto" max-width="228" src="@/assets/images/logo-wide.jpg" />
        <div class="text-center text-h5 py-5">Acceso Participantes</div>
        <div v-if="account.state">
          <v-alert color="info" variant="tonal" title="Activa tú cuenta">
            <div class="text-medium-emphasis text-caption">
              Por ser la primera vez que ingresas, te hemos enviado un correo electrónico a la cuenta <b>{{ account.mail }}</b> para que puedas validar tú cuenta.
            </div>
          </v-alert>
        </div>
        <div v-if="!account.state">
          <div class="text-subtitle-1 text-medium-emphasis">Número de documento</div>
          <v-text-field v-model="form.document" density="compact" placeholder="Número de documento" prepend-inner-icon="mdi-email-outline" variant="outlined" 
          onkeypress="return event.charCode>=48 && event.charCode<=57"
          :error-messages="v$.document.$errors.map(e => e.$message)"/>
          <div class="text-subtitle-1 text-medium-emphasis d-flex align-center justify-space-between">
            Contraseña
            <a class="text-caption text-decoration-none text-blue" href="#/access/remember" rel="noopener noreferrer" target="_self" >
              Olvidaste tu contraseña?
            </a>
          </div>
          <v-text-field v-model="form.password"
            :append-inner-icon="visible ? 'mdi-eye-off' : 'mdi-eye'"
            :type="visible ? 'text' : 'password'"
            :error-messages="v$.password.$errors.map(e => e.$message)" 
            density="compact"
            placeholder="Ingresa tu contraseña"
            prepend-inner-icon="mdi-lock-outline"
            variant="outlined"
            @click:append-inner="visible = !visible"
          />
          <v-alert variant="tonal" v-if="warning">
            <div class="text-medium-emphasis text-caption">
              <b>Advertencia:</b> Después de 3 intentos consecutivos fallidos, tu cuenta será temporalmente desactivada. 
              Soporte: sleon@uwcolombia.org
            </div>
          </v-alert>
          <v-alert color="error" icon="$error" title="Error" variant="tonal" v-if="error">
            <div class="text-caption">
              {{ error }}
            </div>
          </v-alert>
          <v-btn class="my-5" color="blue" size="large" variant="tonal" block text="Iniciar sesión" :loading="process" @click="singin"/>
        </div>        
        <v-card-text class="text-center">
          <a class="text-blue text-decoration-none" href="../" rel="noopener noreferrer" target="_blank">
            <v-icon icon="mdi-chevron-left"></v-icon>Regresar
          </a>
        </v-card-text>
      </v-card>
    </div>
    
  </div>
</template>
<script setup>
  import { ref, reactive, computed } from 'vue';
  import { useRouter } from 'vue-router'
  import { useVuelidate } from '@vuelidate/core'
  import { required, numeric, helpers } from '@vuelidate/validators'
  import axios from 'axios'
  import Params from "../models/params";

  const form = reactive({
    document: null,
    password: null
  });

  const rules = computed(() => {
    return{
      document: { required: helpers.withMessage('Campo requerido.', required), numeric: helpers.withMessage('Solo números.', numeric) },
      password: { required: helpers.withMessage('Campo requerido.', required) }
    }
  })

  const v$ = useVuelidate(rules, form)
  const router = useRouter()
  const params = ref(new Params)

  const visible = ref(false)
  const process = ref(false)
  const warning = ref(false)
  const account = reactive({
    state: false,
    mail: null
  })
  const error = ref(null)

  async function singin () {
    error.value = null
    const result = await v$.value.$validate()
    if(!result){
      return
    }

    process.value = true
    try {
      const frm = new FormData
      frm.append('action','signin')
      frm.append('document',form.document)
      frm.append('password',form.password)
      await axios.post(params.value.controller+'beneficiario.php',frm)
      .then(res => {
        process.value = false
        const result = res.data
        if(result.status){
          if(result.data.user_state){
            localStorage.inscription = result.data.id
            localStorage.document = result.data.documento_numero
            localStorage.names = result.data.nombres
            localStorage.email = result.data.correo_principal
            localStorage.tokenaccess = result.token
            router.push({name: "profilehome"})
          }else{
            account.mail = result.data.correo_principal;
            account.state = true;
          }
        }else{
          error.value = 'Los datos de accesos son incorrectos, por favor intente nuevamente.'
        }
      });
    } catch (err) {
      error.value = err.$message;
    }
  }

</script>